import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AddLockComponent } from 'src/app/building-managment/building-unit-details/add-lock/add-lock.component';
import { IDevice } from 'src/app/building-managment/building-unit-details/add-lock/lock-management-interfaces';
import { DeviceManagementComponent } from 'src/app/building-managment/building-unit-details/device-management/device-management.component';
import { ViewAlertDetailsComponent } from 'src/app/building-managment/building-unit-details/view-alert-details/view-alert-details.component';
import { DeviceSettingsComponent } from 'src/app/building-managment/device-settings/device-settings.component';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';

@Component({
  selector: 'app-shared-access-point-list',
  templateUrl: './shared-accesspoint-devices-list.component.html',
  styleUrls: ['./shared-accesspoint-devices-list.component.scss'],
})
export class SharedAccesspointDevicesListComponent
  implements OnInit, OnDestroy
{
  @Input() deviceList!: Observable<IDevice[] | undefined>;
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  subscription: Subscription | undefined;
  sharedData: any;

  constructor(
    private commonService: CommonService,
    private helperService: HelperService,
    private sharedDataService: SharedDataService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   * @description: #navigateToDeviceInfo function opens the modal poup for Lock Settings.
   * @param { string } deviceId
   * @param { string } deviceName
   * @output { void }
   */

  navigateToDeviceInfo(
    deviceId: string,
    deviceName: string,
    batteryPercentage: string,
    activationState: string,
    entity: string
  ): void {
    this.helperService.openModalDialog(
      DeviceSettingsComponent,
      {
        deviceId,
        deviceName,
        parentType: entity,
        batteryPercentage: batteryPercentage,
        activationState: activationState,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }

  /**
   * @description: #addDevice Function will open the modal for assigning a device
   * @inut {none}
   * @output {void}
   */
  addDevice(): void {
    const dialogInstance = this.helperService.openModalDialog(
      DeviceManagementComponent,
      {
        accessPointId: this.sharedData?.selectedAccessPoint?.accessPointId,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }
  onSeeDetails(title: string) {
    this.helperService.openModalDialog(
      ViewAlertDetailsComponent,
      {
        title,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
  }

  /**
   * @description: #getPartnerDeviceLockImg function recieves battery deviceState and returns the image src
   * @param { string } deviceState
   * @returns { string } src
   */
  getPartnerDeviceLockImg(deviceState: string): string {
    let imageType = '';
    switch (deviceState) {
      case CONSTANTS.OFFLINE:
        imageType = 'ico-lock-circle-outline-red.svg';
        break;
      case CONSTANTS.ONLINE:
        imageType = 'ico-home-lock.svg';
        break;
      case '':
        imageType = 'ico-lock-gray-circle.svg';
        break;
      default:
        imageType = 'ico-lock-gray-circle.svg';
        break;
    }
    return '/assets/svg/' + imageType;
  }

  /**
   * @description: #navigateToPartnerDeviceInfo function opens the modal poup for Partner Device Settings.
   * @param { string } deviceId
   * @param { string } deviceName
   * @param { string } entity
   * @output { void }
   */

  navigateToPartnerDeviceInfo(
    deviceId: string,
    deviceName: string,
    deviceType: string,
    entity: string
  ): void {
    this.helperService.openModalDialog(
      DeviceSettingsComponent,
      {
        deviceId,
        // doorDeviceId: this.doorDeviceId,
        deviceName,
        deviceType,
        // accessPointId: this.selectedAccessPoint?.accessPointId,
        // accessPointName: this.selectedAccessPoint?.accessPointName,
        parentType: entity,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }
  /**
   * @description: runs just before component unmount. Unsubscribes the sharedDataService service
   * @input {none}
   * @output {void}
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
